
// DUPLICATO CON IL SERVER
/*
[
    {
        "menuId": null,
        "menuTitle": null,
        "menuPrice": null,
        "productId": "aaa",
        "productTitle": "AAA-Title",
        "productPrice": "11",
        "quantity": 3,
        "delivered":

        // "settled": null
    },
    {
        "menuId": null,
        "menuTitle": null,
        "menuPrice": null,
        "productId": "bbb",
        "productTitle": "BBB-Title",
        "productPrice": "22",
        "quantity": 2,
        "delivered":

        // "settled": null
    },
    {
        "menuId": null,
        "menuTitle": null,
        "menuPrice": null,
        "productId": "ccc",
        "productTitle": "CCC-Title",
        "productPrice": "33",
        "quantity": 3,
        "delivered":

        // "settled": null
    }
]
*/

  // Compatta un array per productId aggregando le quantity, ignora i menuId, NON BELLISSIMO
  // USATO IN (riporto solo le funzioni client)
  // Order.js per calcolare il riassunto dell'ordine mostrando le quantità totali
  const compact = (order) => {
    const res = [];
    [...order].forEach((item) => {
      const existing = res.find((el) => el.productId === item.productId);
      if (existing) {
        existing.quantity += item.quantity
        existing.delivered += item.delivered;
        existing.free += item.free;
      } else {
        res.push(item);
      }
    });
    return res;
  };
export default compact